export enum IssueCreditNoteFlowType {
  FROM_BILLING_HISTORY = 'billing-history',
  FROM_INVOICE_TABLE = 'invoice-table',
}
